import { useEffect } from 'react';

import { customersApi } from 'src/app/services/Customers/Customers.service';
import { Layout, NotFound } from 'src/components/base';
import { LoadingOverlay } from 'src/components/base/LoadingOverlay/LoadingOverlay';
import { CustomerLeadSteps } from 'src/components/customers/steps/CustomerLeadSteps';
import { CustomersContext } from 'src/pages/CustomersPage/CustomersPage.context';
import { useCustomersContextCreator } from 'src/pages/CustomersPage/CustomersPage.context.hooks';

type CustomersPageProps = {
  customerProductLeadId: string;
};

export function CustomersPage({ customerProductLeadId }: Readonly<CustomersPageProps>) {
  const customersContext = useCustomersContextCreator();

  const [
    {
      data: initialCustomerProductLeadData,
      loading: isInitialCustomerProductLeadDataLoading,
      error: initialCustomerProductLeadDataError,
    },
  ] = customersApi.useGetCustomerProductLeadQuery(customerProductLeadId);

  // biome-ignore lint/correctness/useExhaustiveDependencies: false
  useEffect(() => {
    if (initialCustomerProductLeadData) {
      customersContext.updateCustomerLeadProduct(initialCustomerProductLeadData);
    }
  }, [initialCustomerProductLeadData]);

  return (
    <CustomersContext.Provider value={customersContext}>
      <Layout>
        <LoadingOverlay
          className="flex-1 flex column nowrap justify-content-start align-items-stretch"
          isFirstLoading={isInitialCustomerProductLeadDataLoading}
          indicatorSize={64}
        >
          {initialCustomerProductLeadDataError ? (
            <NotFound />
          ) : (
            <CustomerLeadSteps customerProductLeadId={customerProductLeadId} />
          )}
        </LoadingOverlay>
      </Layout>
    </CustomersContext.Provider>
  );
}
